import { createSlice, createSelector } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

const MODAL_NAMES = {
  ASSIGN_CATEGORY_TO_PRODUCT: 'ASSIGN_CATEGORY_TO_PRODUCT',
  ADD_EDIT_PRODUCT_MODAL: 'ADD_EDIT_PRODUCT_MODAL',
  COPY_PRODUCT_MODAL: 'COPY_PRODUCT_MODAL',
  EXPORT_PROPERTY_MODAL: 'EXPORT_PROPERTY_MODAL',
  IMPORT_PROPERTY_MODAL: 'IMPORT_PROPERTY_MODAL',
  PUBLICATION_SETUP_MODAL: 'PUBLICATION_SETUP_MODAL',
  PUBLICATION_VALIDATE_VIEW_MODAL: 'PUBLICATION_VALIDATE_VIEW_MODAL',
  TRANSFER_ALL_ENTITIES_TO_MEMBER: 'TRANSFER_ALL_ENTITIES_TO_MEMBER',
  REASSIGN_GLN_TO_MEMBER: 'REASSIGN_GLN_TO_MEMBER',
  ADD_FOLDER_TO_APL: 'ADD_FOLDER_TO_APL',
  MOVE_ASSET_TO_MEMBER: 'MOVE_ASSET_TO_MEMBER',
  CREATE_FOLDER: 'CREATE_FOLDER',
  EDIT_FOLDER: 'EDIT_FOLDER',
  CREATE_QUERY: 'CREATE_QUERY',
  ADD_ITEMS_TO_FOLDER: 'ADD_ITEMS_TO_FOLDER',
  MANAGE_QUERIES: 'MANAGE_QUERIES',
  IMPERSONATE_USER: 'IMPERSONATE_USER',
  IMPERSONATE_MEMBER: 'IMPERSONATE_MEMBER',
  CREATE_MASTER_APL: 'CREATE_MASTER_APL',
  CREATE_APL: 'CREATE_APL',
  EDIT_APL: 'EDIT_APL',
  UPDATE_MASTER_APL: 'UPDATE_MASTER_APL',
  //* APL
  ADD_TO_APL: 'ADD_TO_APL',
  ADD_TO_NEW_APL: 'ADD_TO_NEW_APL',
  MEMBER_MAINTAIN: {
    CREATE: 'CREATE_MEMBER',
  },
  EXPORT_BULK_PRODUCT_OVERLAY: 'EXPORT_BULK_PRODUCT_OVERLAY',
  IMPORT_BULK_PRODUCT_OVERLAY: 'IMPORT_BULK_PRODUCT_OVERLAY',
};

const initialState = {
  modalVisibleNames: [],
};

export const globalModalSlice = createSlice({
  name: 'globalModal',
  initialState,
  reducers: {
    openGlobalModal: (state, action) => {
      state.modalVisibleNames = action.payload;
    },
  },
});

export const { openGlobalModal } = globalModalSlice.actions;

export const selectGlobalModal = (state) => state.globalModal;

export const makeSelectVisibleModalNames = () =>
  createSelector(selectGlobalModal, (state) => state.modalVisibleNames);

export const globalModalReducer = globalModalSlice.reducer;

const useGlobalModal = () => {
  const dispatch = useDispatch();

  const visibleModalNames = useSelector(makeSelectVisibleModalNames());

  const checkModalVisible = (modalName) => {
    return visibleModalNames.includes(modalName);
  };

  const openModal = (modalName) => {
    const newVisibleModalNames = [
      ...new Set([...visibleModalNames, modalName]),
    ];

    dispatch(openGlobalModal(newVisibleModalNames));
  };

  const closeModal = (modalName) => {
    const newVisibleModalNames = visibleModalNames.filter(
      (modalItemName) => modalItemName !== modalName
    );

    dispatch(openGlobalModal(newVisibleModalNames));
  };

  const closeAllModal = () => {
    dispatch(openGlobalModal([]));
  };

  const closeModalList = (modalList) => {
    const newVisibleModalNames = visibleModalNames.filter(
      (item) => !modalList.includes(item)
    );
    dispatch(openGlobalModal(newVisibleModalNames));
  };

  return {
    MODAL_NAMES,
    checkModalVisible,
    openModal,
    closeModal,
    closeAllModal,
    closeModalList,
  };
};

export default useGlobalModal;
